import { Typography, useTheme } from "@mui/material";

import { InfoTooltip } from "./InfoTooltip.js";

export interface FormLabelProps {
  label: string;
  error?: boolean;
  isAddressField?: boolean;
  tooltip?: string;
}
export const FormLabel = (props: FormLabelProps) => {
  const { label, error, isAddressField = false, tooltip } = props;

  const theme = useTheme();
  const style = {
    fontSize: 15,
    display: tooltip ? "inline-flex" : "block",
    marginBottom: isAddressField ? theme.spacing(1.5) : theme.spacing(1),
    fontWeight: "bold",
    color: error ? theme.palette.error.main : theme.palette.text.primary,
  };

  return (
    <>
      <Typography data-testid="label-id" sx={style}>
        {label}
      </Typography>
      {tooltip && <InfoTooltip text={tooltip} />}
    </>
  );
};
